import React, { useState, useEffect, useCallback } from "react";
import PageNavigation from "components/CustomComponents/Navbars/PageNavigation";

function NavigateToNewPortal() {
  const [open, setOpen] = useState(false);

  const pdfUrl =
    "https://s3.ap-southeast-1.wasabisys.com/gocoderz/Students-Report-Manual.pdf";
  const pptUrl = "https://example.com/your-presentation.pptx"; // TODO: replace with real PPT link

  const onKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === "Escape") setOpen(false);
  }, []);

  useEffect(() => {
    if (open) document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onKeyDown]);

  return (
    <>
      <PageNavigation logoText={"Dashboard"} back={"/assessment-dashboard"} />

      {/* Page body */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          //   minHeight: "100vh",
          padding: "16px",
          textAlign: "center",
          marginTop: "200px",
        }}
      >
        <h1
          style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}
        >
          Reports are available here:{" "}
          <a
            href="https://app.questplus.in/login"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#32b8b0" }}
          >
            https://app.questplus.in
          </a>
        </h1>

        <p style={{ color: "#666", marginBottom: "24px", fontSize: "16px" }}>
          Please log in with the same credentials and follow the steps below:
        </p>

        <ol
          style={{
            textAlign: "left",
            maxWidth: "640px",
            lineHeight: 1.6,
            fontSize: "16px",
            marginBottom: "24px",
          }}
        >
          <li>
            Click on the <span style={{ fontWeight: 600 }}>Login</span> button.
          </li>
          <li>
            Enter your existing{" "}
            <span style={{ fontWeight: 600 }}>username</span> and{" "}
            <span style={{ fontWeight: 600 }}>password</span>.
          </li>
          <li>Latest report will be available on the dashboard.</li>
          <li>
            Reports will be visible only{" "}
            <strong>after the test time ends</strong>.
          </li>
          <li>Select the desired report to view.</li>
          <li>
            <button
              onClick={() => setOpen(true)}
              style={{
                border: "none",
                background: "transparent",
                color: "#0b63c6",
                textDecoration: "underline",
                padding: 0,
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              Click here to preview the PDF for detailed steps
            </button>
            .
          </li>
        </ol>
      </div>

      {/* Modal */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            zIndex: 9999,
          }}
        >
          <div
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: "960px",
              height: "85vh",
              background: "#fff",
              borderRadius: "12px",
              boxShadow:
                "0 10px 20px rgba(0,0,0,0.15), 0 6px 6px rgba(0,0,0,0.1)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Modal header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #eee",
              }}
            >
              <div style={{ fontWeight: 700 }}>
                Student Report Manual (Preview)
              </div>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "14px",
                    color: "#0b63c6",
                    textDecoration: "underline",
                  }}
                >
                  Open in new tab
                </a>
                <button
                  onClick={() => setOpen(false)}
                  aria-label="Close"
                  style={{
                    border: "none",
                    background: "#f2f2f2",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              </div>
            </div>

            {/* Modal content (PDF iframe) */}
            <div style={{ flex: 1, background: "#fafafa" }}>
              <iframe
                src={pdfUrl}
                title="Student Report Manual PDF"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NavigateToNewPortal;
